import React, { PureComponent } from 'react';
import Plot from 'react-plotly.js';
import RatingsChart from '../../teacher-analytics/components/ratings-chart';
import { Grid, Segment } from 'semantic-ui-react';

export default class AnalysisChart extends PureComponent {
  render() {
    const { data } = this.props;
    const cumulativeSum = (sum => value => (sum += value))(0);
    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Plot
              data={[
                {
                  x: data.month,
                  y: data.completion_metric.map(cumulativeSum),
                  type: 'scatter',
                },
              ]}
              layout={{
                width: 500,
                height: 300,
                title: '% Syllabus Completion by Month',
              }}
            />
          </Grid.Column>
          <Grid.Column>
            <Segment basic>
              <RatingsChart data={data.rating_objs} />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Plot
              data={[
                {
                  x: ['Baseline', ...data.month],
                  y: [data.baseline, ...data.performance_metric],
                  type: 'scatter',
                },
              ]}
              layout={{ width: 500, height: 300, title: 'OPM By Month' }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
